import Container from '@/components/@base/container';
import { SegmentProps } from '@/components/wallets-section/types';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import {
  calcDaysBetween2Date,
  currency, isDesktop,
  isZeroAmount,
  numberInputProps,
  toMilliSecond,
} from '@/lib/helper';
import { toPersianNumberic } from 'to-persian-letter-currency';
import Button from '@/components/@base/button';
import { INPUT_TYPES, SIZE_ENUM } from '@/components/@base/@types';
import Input from '@/components/@base/input/text';
import { useEffect, useState } from 'react';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';
import useBottomSheetStore from '@/store/bottom-sheet-store';
import useHomeStore from '@/store/home';
import AcceptSelection from '@/components/accept-selection';
import { usePostValidateSelection, usePostValidateSelections } from '@/services/hooks';
import {
  notSelectedSegmentsNotSpendable,
  selectedSegments,
  selectedVouchers,
} from '@/services/models/api.models';
import mockWalletLogo from '@/assets/mock-items/default-segment-icon.svg';
import RadioGroup from '../@base/input/radio/group';
import Circular from '@/components/@base/input/radio/circular';
import { RadioOption } from '@/components/@base/input/radio';
import cn from '@/lib/clsxm';
import useCommonModalStore from '@/store/common-modal-store';

const EditWallet = ({data, handleClickOnWallet}: {data:SegmentProps, handleClickOnWallet: () => void}) => {
  const {
    balance,
    segmentId,
    expirationDateTime,
    segmentTypeId,
    upgTitle,
    upgLogo,
    cardNumber,
    selected,
    usageBalance,
    isEdited
  } = data
  const { setSegments, segments, usableClientVouchers, setChooseValidate } = useUserWalletsVouchersStore()
  const { setShowBottomSheet } = useBottomSheetStore()
  const { remainInvoice, invoice,setRemainInvoice } = useHomeStore();
  const { mutate: mutateValidation, isPending: pendingValidation} = usePostValidateSelections();
  const [withdraw, setWithdraw] = useState('');
  const [selectedItem, setSelectedItem] = useState<string>('DEFAULT_VALUE');
  const remainAmount = remainInvoice + usageBalance!
  const handleSelectEditedSegment = (updatedSegments: SegmentProps[], notSelectedSegmentsNotSpendable?: notSelectedSegmentsNotSpendable[]) => {
    segments?.map(s => {
      notSelectedSegmentsNotSpendable && notSelectedSegmentsNotSpendable.map(ns=> {
        if(s.segmentId === ns.segmentId){
          s.isDisable = true;
        }
      })
      if (s.segmentId === data.segmentId) {
        s.selected = true;
        s.isEdited = true;
        s.usageBalance = +withdraw.replace(/,/g, '');
      }
      updatedSegments.push(s);
    });
    setSegments(updatedSegments);
    if (isDesktop()) {
      setShow(false);
    } else {
      setShowBottomSheet(false);
    }
  }
  const {setShow} = useCommonModalStore()
  const handleEditWalletAmount = () => {
    if(selectedItem === "DEFAULT_VALUE") {
      if(!selected){
        handleClickOnWallet()
      } else if(remainInvoice >= 0 && !pendingValidation) {
        const updatedSegments: SegmentProps[] = [];
        segments?.map(s => {
          if (s.segmentId === data.segmentId) {
            s.selected = true;
            s.usageBalance = s.balance >= (remainInvoice + isZeroAmount(data.usageBalance)) ? (remainInvoice + isZeroAmount(data.usageBalance)) : s.balance;
            s.isEdited = false;
          }
          updatedSegments.push(s);
        });
        setSegments(updatedSegments);
      }
      if (isDesktop()) {
        setShow(false)
      }else {
        setShowBottomSheet(false)
      }
    } else {
      sessionStorage.setItem('isSelectedVoucherOrWallet', 'true')
      const updatedSegments: SegmentProps[] = [];
      if(remainInvoice >= 0 && !pendingValidation) {
        const selectedSegments: selectedSegments[] = [];
        segments?.map(s => {
          if (s.selected) {
            selectedSegments.push({
              segmentId: s.segmentId,
              amount: s.usageBalance!
            });
          }
        });
        const selectedVouchers: selectedVouchers[] = [];
        usableClientVouchers?.map(s => {
          if (s.selected) {
            selectedVouchers.push({
              voucherId: s.voucherId,
            });
          }
        });
        if(data.selected) {
          handleSelectEditedSegment(updatedSegments)
        } else mutateValidation({
          selectedSegments: selectedSegments,
          lastSelectedSegment: {
            segmentId: data.segmentId,
            amount: +withdraw.replace(/,/g, '')
          },
          notSelectedSegments: segments.filter(i => i.segmentId !== data.segmentId).filter(i => !i.selected),
          lastSelectedVoucher: {},
          selectedVouchers: selectedVouchers,
          notSelectedVouchers: usableClientVouchers.filter(i => !i.selected)
        }, {
          onSuccess: (res) => {
            if(res?.responseCode === 0 ) {
              handleSelectEditedSegment(updatedSegments, res?.notSelectedSegmentsNotSpendable)
                usableClientVouchers?.map(v => {
                  res.notSelectedVouchersNotSpendable.map(ns=> {
                    if(v.voucherId === ns.voucherId){
                      v.isDisable = true;
                    }
                  })
                })
                setSegments(updatedSegments);
            } else if(res?.responseCode === 10 || res?.responseCode === 15){
              segments?.map(s => {
                if (s.segmentId === data.segmentId) {
                  updatedSegments.push({
                    ...s,
                    usageBalance : +withdraw.replace(/,/g, '')
                  });
                } else {
                  updatedSegments.push(s);
                }

              });
              // setChooseValidate(res);
              setShowBottomSheet(true,{
                Body: () => <AcceptSelection updatedSegments={updatedSegments}/>
              });

            }
          }
        })
      }
    }
  }
  const NumberWithdraw = () => {
    return Number(withdraw.replace(/,/g, ''))
  }
  const onChangeRadioGroup = (val: string) => {
    setSelectedItem(val);
  }
  useEffect(() => {
    if(usageBalance! > 0 && isEdited) {
      setWithdraw(String(usageBalance).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
      setSelectedItem('CUSTOM_VALUE');
    }
  }, []);
  return (
    <Container center className='flex-col pt-6'>
      <Container center className='w-full flex-col gap-1 px-4'>
        {upgLogo && upgLogo?.length > 0 && (
          <img src={upgLogo} alt='' className='w-15 h-10 rounded' />
        )}
        {(!upgLogo || upgLogo?.length === 0) && (
          <img src={mockWalletLogo} alt='' className='w-15 h-10 rounded' />
        )}
        <Text className='mt-2 text-lg text-grayLight-1000 dark:text-grayLight-0' medium>
          {' '}
          {upgTitle}
        </Text>
        {expirationDateTime && cardNumber && (
          <Text className='text-sm text-grayLight-600 dark:text-grayDark-300'>
            {' '}
            {cardNumber}
          </Text>
        )}
        {expirationDateTime && cardNumber && (
          <Text className='text-[12px] text-grayLight-600 dark:text-grayDark-300'>
            {localization.remainExpiration(
              calcDaysBetween2Date(toMilliSecond(expirationDateTime)!),
            )}
          </Text>
        )}
        <Container
          center
          className='mt-4 w-full justify-between rounded-xl bg-grayLight-50 p-4 dark:bg-grayDark-750'
        >
          <Text className='text-md text-grayLight-1000 dark:text-grayLight-0' medium>
            {' '}
            {localization.balance}
          </Text>
          <Text
            className='flex items-center text-[13px] text-md text-grayLight-1000 dark:text-grayLight-0'
            medium
          >
            {currency(balance)}
            <span className='ml-1 mr-1 text-[13px] text-grayLight-1000 dark:text-grayLight-0'>
              {localization.rial}
            </span>
          </Text>
        </Container>
      </Container>
      <Container className='mt-4 flex w-full flex-col border-b border-t border-grayLight-50 py-2 dark:border-grayDark-750'>
        <Text className='py-2 pr-4 text-sm text-grayLight-650 dark:text-grayLight-0' medium>
          {localization.howToPurchase}
        </Text>
        <RadioGroup
          value={selectedItem}
          className='my-4 pr-[22px]'
          onChange={(value) => onChangeRadioGroup(value as string)}
        >
          <RadioOption value={'DEFAULT_VALUE'}>
            {({ checked }) => (
              <Circular
                checked={checked}
                size={SIZE_ENUM.LG}
                className='items-start'
                circulCalssName='mt-5'
              >
                <Text size={SIZE_ENUM.MD} className='text-black dark:text-white'>
                  {localization.default}
                </Text>
                <Text className='mb-4 text-black dark:text-grayDark-75'>
                  {localization.defaultAmount}
                </Text>
              </Circular>
            )}
          </RadioOption>
          <RadioOption value={'CUSTOM_VALUE'}>
            {({ checked }) => (
              <Circular
                checked={checked}
                size={SIZE_ENUM.LG}
                className='items-start pl-4'
                circulCalssName='mt-5'
              >
                <Container>
                  <Text size={SIZE_ENUM.MD} className='text-black dark:text-white'>
                    {localization.userWantedAmount}
                  </Text>
                  <Text className={cn('text-black dark:text-grayDark-75', selectedItem === 'CUSTOM_VALUE' && 'mb-3')}>
                    {localization.userEnteredAmount}
                  </Text>
                  {selectedItem === 'CUSTOM_VALUE' && (
                    <Input
                      tabIndex={-1}
                      errorState={
                        (NumberWithdraw() > balance && NumberWithdraw() < remainAmount) ||
                        NumberWithdraw() > remainAmount
                      }
                      maxLength={15}
                      size={SIZE_ENUM.XL}
                      value={withdraw}
                      className='w-full border-grayLight-100 bg-grayLight-40 focus:border-black focus:dark:border-white focus:border-2 pr-3.5 text-right text-[15px] text-grayLight-1000 dark:border-grayDark-700 dark:bg-grayDark-900 dark:text-grayLight-0'
                      type={INPUT_TYPES.TEL}
                      stickyText={localization.rial}
                      placeholder={'0'}
                      {...numberInputProps((formattedValue) => setWithdraw(formattedValue))}
                    />
                  )}
                  {selectedItem === 'CUSTOM_VALUE' &&
                    NumberWithdraw() <= balance &&
                    NumberWithdraw() <= remainAmount && (
                      <Text className='mt-2 w-full text-right text-sm text-grayLight-600 dark:text-grayDark-300'>
                        {withdraw?.length > 0 ? toPersianNumberic(+withdraw.replaceAll(',', '')) : localization.inputWithdrawAmount}
                      </Text>
                    )}
                  {selectedItem === 'CUSTOM_VALUE' &&
                    NumberWithdraw() > balance &&
                    NumberWithdraw() < remainAmount && (
                      <Text className='mt-2 w-full text-right text-sm text-red dark:text-red-300'>
                        {localization.graterThanWalletAmount}
                      </Text>
                    )}
                  {selectedItem === 'CUSTOM_VALUE' && NumberWithdraw() > remainAmount && (
                    <Text className='mt-2 w-full text-right text-sm text-red dark:text-red-300'>
                      {localization.graterThanPayableAmount}
                    </Text>
                  )}
                </Container>
              </Circular>
            )}
          </RadioOption>
        </RadioGroup>
      </Container>
      <Container className='w-full p-4 pb-6 sticky'>
        <Button
          className='text-md h-[54px] w-full rounded-full'
          onClick={handleEditWalletAmount}
          disabled={ selectedItem === 'CUSTOM_VALUE' && (
            NumberWithdraw() > balance ||
            NumberWithdraw() > remainAmount ||
            pendingValidation ||
            NumberWithdraw() === 0
          )}
          isLoading={pendingValidation}
        >
          {localization.confirm}
        </Button>
      </Container>
    </Container>
  );
}
export default EditWallet